import React, { useContext } from "react";
import "./Footer.css";

import visaIcon from "../../assets/visa.svg";
import masterCardIcon from "../../assets/master_card.svg";
import amexIcon from "../../assets/amex.svg";
import padlockIconGray from "../../assets/padlockIconGray.svg";
import {
  privacity_advice_url,
  terms_telcel_url,
} from "../../constants/constants";

import { REQUEST_BALANCE_HOME } from "../../constants/callTrackingConstants";
import AppContext from "../../AppContext";



export default function Footer() {
  const { doCallTracking, number } = useContext(AppContext);

  return (
    <div className="footer__container">
      <div className="footer__section">
        <img alt="visa" src={visaIcon} className="footer__section__img" />
        <img
          alt="mastercard"
          src={masterCardIcon}
          className="footer__section__img"
        />
        <img alt="amex" src={amexIcon} className="footer__section__img" />
        <img alt="ssl" src={padlockIconGray} />
        <span>SSL Secure Encriptation</span>
      </div>

      <div className="footer__section terms__and__conditions">
        <a
          href={terms_telcel_url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            doCallTracking(
              `${REQUEST_BALANCE_HOME.CLIC_TERMINOS_Y_CONDICIONES.elementName}`,
              REQUEST_BALANCE_HOME.CLIC_TERMINOS_Y_CONDICIONES.elementLocation,
              number
            );
          }}
        >
          Términos y condiciones
        </a>

        <a
          href={privacity_advice_url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            doCallTracking(
              `${REQUEST_BALANCE_HOME.CLIC_AVISO_DE_PRIVACIDAD.elementName}`,
              REQUEST_BALANCE_HOME.CLIC_AVISO_DE_PRIVACIDAD.elementLocation,
              number
            );
          }}
        >
          Aviso de privacidad
        </a>
      </div>

      <div className="footer__section">
        <p className="copyright__text">
          ©2023 Radiomóvil Dipsa S.A. de C.V. Todos los derechos reservados
        </p>
      </div>
    </div>
  );
}
